/*
  customsirge_pdp_bundle.js
  Purpose:  Behaviour for snippets/customsirge_pdp_bundle.liquid. Opens the panel
            from the PDP "Build your bundle" button, counts packs, shows the
            Recharge tier the box is in, and adds the box to the cart as one
            Recharge dynamic bundle (Build Your Own Box).
  Data:     data-* on [data-customsirge-pdp-bundle] and its items (Liquid), plus
            Recharge bundle settings (minimum, tier discounts, allowed collection)
            read with the Recharge Storefront SDK when the panel first opens.
  Needs:    assets/customsirge_recharge.js (loaded before this file) — the shared
            loader for the self-hosted SDK 2.6.0, the bundle rules, plan matching
            and the cart add. The Build a Box page uses the same one.
  Owns:     window.Customsirge components['pdp-bundle']
  Owner:    Sirge, feat/pdp-bundle-drawer

  How the cart add works (Recharge docs, Storefront SDK "Bundles"):
    recharge.bundle.getDynamicBundleItems(bundle, handle) returns one cart line
    per selected product with the _rc_bundle* properties (and the selling plan
    when subscribing); those lines go to /cart/add.js in one request. Recharge
    then treats them as a single bundle and applies its tier discount.

  Fallback: until the SDK and settings load, the PDP button keeps its normal
  link to the bundle page. If anything fails, the shopper is sent there.
*/

(function () {
  'use strict';

  if (!window.Customsirge || !window.Customsirge.register) return; // kit not loaded

  window.Customsirge.register('pdp-bundle', {
    selector: '[data-customsirge-pdp-bundle]',
    init: function (root) {
      var R = window.CustomsirgeRecharge;
      if (!R) return; // shared loader missing: the button stays a link to the bundle page

      var section = root.closest('[data-customsirge-pdp-main]') || document;
      /* The drawer is position:fixed; an animated (transformed) ancestor would trap
         it inside the buy box, so it lives directly under <body>. Drop any copy left
         there by an earlier render of this section (theme editor re-renders). */
      Array.prototype.forEach.call(document.querySelectorAll('body > #' + CSS.escape(root.id)), function (old) {
        if (old !== root) old.remove();
      });
      var home = { parent: root.parentNode, next: root.nextSibling };
      document.body.appendChild(root);
      var drawerEl = root.querySelector('[data-customsirge-pdp-bundle-drawer]');
      var unitsPerPack = Number(root.getAttribute('data-units-per-pack')) || 4;
      var unitLabel = root.getAttribute('data-unit-label') || 'cans';
      var trigger = section.querySelector('.customsirge-pdp-main__bundle-link');
      var fallbackUrl = root.getAttribute('data-bundle-url');
      var store = root.getAttribute('data-store');
      var sdkSrc = root.getAttribute('data-sdk-src');
      var moneyFormat = root.getAttribute('data-money-format');
      var minMessage = root.getAttribute('data-min-message') || '';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-customsirge-pdp-bundle-item]'));
      var tierRow = root.querySelector('[data-customsirge-pdp-bundle-tier-row]');
      var fill = root.querySelector('[data-customsirge-pdp-bundle-fill]');
      var status = root.querySelector('[data-customsirge-pdp-bundle-status]');
      var atc = root.querySelector('[data-customsirge-pdp-bundle-atc]');
      var total = root.querySelector('[data-customsirge-pdp-bundle-total]');
      var errorEl = root.querySelector('[data-customsirge-pdp-bundle-error]');
      var freq = root.querySelector('[data-customsirge-pdp-bundle-freq]');
      var modes = Array.prototype.slice.call(root.querySelectorAll('[data-customsirge-pdp-bundle-mode]'));

      var qty = {};
      var settings = null;
      var busy = false;

      function goFallback() {
        if (fallbackUrl) window.location.href = fallbackUrl;
      }

      function mode() {
        var checked = modes.filter(function (m) { return m.checked; })[0];
        return checked ? checked.value : 'onetime';
      }

      function count() {
        return Object.keys(qty).reduce(function (n, k) { return n + qty[k]; }, 0);
      }

      function tierPct(n) {
        return R.percentAt(settings, n, mode() === 'subscribe' ? 'subscription' : 'onetime');
      }

      /* The schedule the shopper picked: the bundle's plan id and its group name. */
      function choice() {
        if (mode() !== 'subscribe' || !freq) return null;
        var opt = freq.querySelector('input:checked');
        return opt ? { id: opt.getAttribute('data-plan-id'), name: opt.value } : null;
      }

      function planFor(item) {
        return R.matchPlan(item.getAttribute('data-plans'), choice());
      }

      /* Display estimate, rounded the way the cart did in testing: subscription %
         first (rounded to the cent), then the tier % (discount rounded down).
         $24.99 -> $19.99 -> $18.00 at 10%. Recharge prices the real cart. */
      function unitPrice(item, n) {
        var base = Number(item.getAttribute('data-price'));
        var plan = planFor(item);
        var price = plan ? Math.round(base * (1 - plan.pct / 100)) : base;
        return price - Math.floor((price * tierPct(n)) / 100);
      }

      /* One column per box size from Recharge's minimum to its maximum (or to the
         last discount tier when there's no maximum): 1/2/3 packs -> "4 / 8 / 12 cans". */
      function renderTiers() {
        if (!settings || !tierRow) return;
        var ref = items[0];
        var top = settings.max != null ? settings.max : settings.min;
        settings.tiers.forEach(function (t) { if (t.qty > top) top = t.qty; });
        top = Math.min(top, settings.min + 5);
        var cols = [];
        for (var q = settings.min; q <= top; q++) cols.push({ qty: q, pct: tierPct(q) });
        var last = cols[cols.length - 1].qty;
        tierRow.innerHTML = '';
        cols.forEach(function (c, i) {
          var div = document.createElement('div');
          div.className = 'customsirge-pdp-bundle__tier';
          div.setAttribute('data-qty', c.qty);
          var open = settings.max == null && i === cols.length - 1;
          var label = c.qty * unitsPerPack + (open ? '+ ' : ' ') + unitLabel;
          var each = ref ? R.money(unitPrice(ref, c.qty), moneyFormat) + '/pack' : '';
          div.innerHTML = '<span class="customsirge-pdp-bundle__tier-qty"></span><span class="customsirge-pdp-bundle__tier-price"></span>';
          div.children[0].textContent = label;
          div.children[1].textContent = c.pct ? each + ' · ' + c.pct + '% off' : each;
          tierRow.appendChild(div);
        });
        var n = count();
        Array.prototype.forEach.call(tierRow.children, function (el) {
          el.classList.toggle('is-active', n >= Number(el.getAttribute('data-qty')));
        });
        /* The bar shares the columns' scale: column k is centred at (k + 0.5) / m, so
           reaching a column's box size fills exactly to that column's label, and the
           bar is full once the largest size is reached. Markers sit under each label. */
        var m = cols.length;
        var pos;
        if (n >= last) pos = 1;
        else if (n <= cols[0].qty) pos = (n / cols[0].qty) * (0.5 / m);
        else {
          pos = 0.5 / m;
          for (var k = 0; k < m - 1; k++) {
            if (n >= cols[k + 1].qty) { pos = (k + 1.5) / m; continue; }
            pos = (k + 0.5) / m + ((n - cols[k].qty) / (cols[k + 1].qty - cols[k].qty)) / m;
            break;
          }
        }
        if (fill) {
          fill.style.width = (pos * 100).toFixed(2) + '%';
          var track = fill.parentNode;
          Array.prototype.forEach.call(track.querySelectorAll('.customsirge-pdp-bundle__mark'), function (el) { el.remove(); });
          cols.forEach(function (c, k) {
            var mark = document.createElement('span');
            mark.className = 'customsirge-pdp-bundle__mark' + (n >= c.qty ? ' is-reached' : '');
            mark.style.left = (((k + 0.5) / m) * 100).toFixed(2) + '%';
            track.appendChild(mark);
          });
        }
      }

      function render() {
        var n = count();
        items.forEach(function (item) {
          var id = item.getAttribute('data-variant-id');
          var q = qty[id] || 0;
          var add = item.querySelector('[data-customsirge-pdp-bundle-add]');
          var stepper = item.querySelector('[data-customsirge-pdp-bundle-stepper]');
          var qEl = item.querySelector('[data-customsirge-pdp-bundle-qty]');
          var plus = item.querySelector('[data-customsirge-pdp-bundle-plus]');
          var full = settings && settings.max != null && n >= settings.max;
          var capped = settings && settings.maxPerVariant != null && q >= settings.maxPerVariant;
          if (add) add.hidden = q > 0;
          if (stepper) stepper.hidden = q === 0;
          if (qEl) qEl.textContent = q;
          if (plus) plus.disabled = Boolean(full || capped);
          if (add) add.disabled = Boolean(full);
        });
        var sum = items.reduce(function (s, item) {
          var q = qty[item.getAttribute('data-variant-id')] || 0;
          return s + q * unitPrice(item, n);
        }, 0);
        var min = settings ? settings.min : 1;
        var ok = n >= min && (!settings || settings.max == null || n <= settings.max);
        atc.disabled = !ok || busy || !settings;
        total.textContent = n > 0 ? '· ' + R.money(sum, moneyFormat) : '';
        if (!settings) status.textContent = '';
        else if (n < min) status.textContent = minMessage.replace('[count]', String(min - n));
        else status.textContent = n * unitsPerPack + ' ' + unitLabel + ' in your bundle' + (tierPct(n) ? ' · ' + tierPct(n) + '% off' : '');
        if (freq) freq.hidden = mode() !== 'subscribe';
        renderTiers();
      }

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      }

      function onKey(e) {
        if (e.key === 'Escape') close();
      }

      function open() {
        root.hidden = false;
        void root.offsetWidth; /* start the slide from off-screen */
        root.classList.add('is-open');
        document.documentElement.classList.add('customsirge-pdp-bundle-lock');
        document.addEventListener('keydown', onKey);
        if (drawerEl) drawerEl.focus({ preventScroll: true });
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (!settings) {
          status.textContent = 'Loading bundle options…';
          R.load(store, sdkSrc)
            .then(function (rc) { return R.settings(rc, root.getAttribute('data-bundle-product-id')); })
            .then(function (s) {
              settings = s;
              var first = root.querySelector('[data-customsirge-pdp-bundle-item][data-current]') || items[0];
              if (first && count() === 0 && !first.classList.contains('is-soldout')) {
                qty[first.getAttribute('data-variant-id')] = 1;
              }
              render();
            })
            .catch(function (e) {
              console.error('[customsirge_pdp_bundle] Recharge settings failed, using the bundle page', e);
              goFallback();
            });
        }
      }

      function close() {
        if (root.hidden) return;
        root.classList.remove('is-open');
        document.documentElement.classList.remove('customsirge-pdp-bundle-lock');
        document.removeEventListener('keydown', onKey);
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }
        window.setTimeout(function () {
          if (!root.classList.contains('is-open')) root.hidden = true;
        }, 320);
      }

      function onTrigger(e) {
        e.preventDefault();
        if (root.hidden) open();
        else close();
      }

      function onClick(e) {
        if (e.target.closest('[data-customsirge-pdp-bundle-close]')) {
          close();
          return;
        }
        var item = e.target.closest('[data-customsirge-pdp-bundle-item]');
        if (!item) return;
        var id = item.getAttribute('data-variant-id');
        if (e.target.closest('[data-customsirge-pdp-bundle-add]') || e.target.closest('[data-customsirge-pdp-bundle-plus]')) {
          qty[id] = (qty[id] || 0) + 1;
        } else if (e.target.closest('[data-customsirge-pdp-bundle-minus]')) {
          qty[id] = Math.max(0, (qty[id] || 0) - 1);
          if (!qty[id]) delete qty[id];
        } else {
          return;
        }
        showError('');
        render();
      }

      function addToCart() {
        if (atc.disabled || !settings) return;
        busy = true;
        render();
        showError('');
        var collectionId = R.collectionFor(settings, root.getAttribute('data-collection-id'));
        var selections = items
          .filter(function (item) { return qty[item.getAttribute('data-variant-id')]; })
          .map(function (item) {
            var sel = {
              collectionId: collectionId,
              externalProductId: item.getAttribute('data-product-id'),
              externalVariantId: item.getAttribute('data-variant-id'),
              quantity: qty[item.getAttribute('data-variant-id')],
            };
            var plan = planFor(item);
            if (plan) sel.sellingPlan = plan.id;
            return sel;
          });
        if (mode() === 'subscribe' && selections.some(function (s) { return !s.sellingPlan; })) {
          busy = false;
          render();
          showError('One of these flavors isn’t available on that delivery schedule. Pick another schedule or one-time.');
          return;
        }
        R.addBundle({
          store: store,
          src: sdkSrc,
          handle: root.getAttribute('data-bundle-handle'),
          bundle: {
            externalProductId: root.getAttribute('data-bundle-product-id'),
            externalVariantId: root.getAttribute('data-bundle-variant-id'),
            selections: selections,
          },
        })
          .then(function () {
            qty = {};
            close();
          })
          .catch(function (e) {
            console.error('[customsirge_pdp_bundle] add failed', e);
            showError(e && e.message ? e.message : 'Something went wrong. Please try again.');
          })
          .finally(function () {
            busy = false;
            render();
          });
      }

      function onModeChange() { render(); }

      if (trigger) {
        trigger.setAttribute('aria-controls', root.id);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', onTrigger);
      }
      root.addEventListener('click', onClick);
      atc.addEventListener('click', addToCart);
      modes.forEach(function (m) { m.addEventListener('change', onModeChange); });
      if (freq) freq.addEventListener('change', onModeChange);

      return function () {
        document.documentElement.classList.remove('customsirge-pdp-bundle-lock');
        document.removeEventListener('keydown', onKey);
        if (home.parent && home.parent.isConnected) home.parent.insertBefore(root, home.next);
        else root.remove();
        if (trigger) trigger.removeEventListener('click', onTrigger);
        root.removeEventListener('click', onClick);
        atc.removeEventListener('click', addToCart);
        modes.forEach(function (m) { m.removeEventListener('change', onModeChange); });
        if (freq) freq.removeEventListener('change', onModeChange);
      };
    },
  });
})();
